import _ from "lodash";
import { RootState } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";

import { selectGroupById } from "@dashboard/groups/store/selectors";
import { productsAdapter } from "@dashboard/products/store";
import { createSelector } from "@reduxjs/toolkit";

const defaultSelectors = productsAdapter.getSelectors<RootState>((state) => state.products.list.products.items);

export const selectProducts = createSelector(
    [(state: RootState) => state, (state: RootState) => state.products.list.products.items.entities],
    (state, products) => {
        const workspaceId = selectCurrentWorkspaceId(state);
        const arr = Object.values(products).filter((item) => item?.workspaceId === workspaceId);
        return _.compact(arr);
    },
);

export const selectProductById = defaultSelectors.selectById;

export const selectProductsByGroupId = createSelector(
    [defaultSelectors.selectAll, (state: RootState, id: number) => selectGroupById(state, id)],
    (products, group) => {
        return products.filter((product) => product.groupId === group?.id);
    },
);
export const selectProductChangelogsById = createSelector(
    [selectProducts, (_state: RootState, productId: number | undefined) => productId],
    (products, productId) => products.find((product) => product.id === productId)?.changes ?? null,
);

export const selectProductStatus = (state: RootState) => {
    return state.products.list.products.status;
};
